import { SvgRepeat } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { LogaltyError } from '@/Logalty/ui/molecules'

export const Step5ErrorScreen = (): JSX.Element => {
  const { t } = useTranslation()
  const { title, description, description2, supportEmail, description3, button } =
    AutoEnrollmentTranslation.confirmationScreen.error

  return (
    <LogaltyError
      title={t(title)}
      description={t(description)}
      description2={
        <>
          {t(description2)}
          <a href={`mailto: ${supportEmail}`}>{t(supportEmail)}</a>
          {t(description3)}
        </>
      }
      buttonLabel={t(button.label)}
      buttonIcon={<SvgRepeat />}
    />
  )
}
